import dayjs from 'dayjs';
import { FormItem } from 'components/use-form';
import { QualificationInfo } from 'model/agency';
import { CAPITAL } from 'pages/regist/const/constant';

export const qualificationFormConfig: Array<FormItem> = [
  {
    name: 'company_name',
    label: '公司主体名称',
  },
  {
    name: 'company_license_no',
    label: '统一社会征信代码',
  },
  {
    name: 'company_reg_address',
    label: '注册地址',
  },
  {
    name: 'company_capital_situation',
    label: '注册资本',
    render: (data: QualificationInfo) => {
      return CAPITAL[data.company_capital_situation || ''] || '-';
    },
  },
  {
    name: 'company_expiretime',
    label: '证件有效期',
    render: (data: QualificationInfo) => {
      if (dayjs(data.company_expiretime).format('YYYY-MM-DD') === '3000-01-01') {
        return '长期';
      }
      return data.company_expiretime ? dayjs(data.company_expiretime).format('YYYY-MM-DD') : '-';
    },
  },
  {
    name: 'company_owner',
    label: '法人名称',
  },
  {
    name: 'company_owner_id_pic',
    label: '法人证件',
    type: 'image',
  },
  {
    name: 'mp_name',
    label: '公众号名称',
  },
  {
    name: 'mp_id',
    label: '公众号ID',
  },
  {
    name: 'company_certification',
    label: '营业执照',
    type: 'image',
  },
  {
    name: 'icp_no',
    label: 'ICP备案号',
    type: 'image',
  },
  {
    name: 'icp_licenses',
    label: 'ICP许可证',
    type: 'file',
  },
  {
    name: 'company_copyright',
    label: '著作权证明',
    type: 'image',
  },
];
